import request from "graphql-request";
import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useState } from "react";
import { baseUrl } from "services/shared/Environment";

export interface NewsletterPageContextValue {
  referral: boolean;
  referrer_email: string;
}

function newsletterReferralEmailQuery(referralCode: string) {
  return `
      query {
        newsletterReferralEmail(referralCode: "${referralCode}")
      }
  `;
}

export const NewsletterPageContext = createContext(null);

export const NewsletterPageContextProvider: React.FC = ({ children }) => {
  const [referrerEmail, setReferrerEmail] = useState<string | null>(null);
  const router = useRouter();
  const referralCode = (router?.query?.r as string) ?? null;

  useEffect(() => {
    if (referralCode) {
      request(
        `${baseUrl()}/api/graphql`,
        newsletterReferralEmailQuery(referralCode)
      ).then((data) => {
        const email = data?.newsletterReferralEmail;
        if (email) {
          setReferrerEmail(email);
        }
      });
    }
  }, [referralCode]);

  const value = {
    referral: referralCode ? true : false,
    referrer_email: referrerEmail ?? "",
  };

  return (
    <NewsletterPageContext.Provider value={value}>
      {children}
    </NewsletterPageContext.Provider>
  );
};

export function useNewsletterPageContext() {
  const context = useContext(NewsletterPageContext);
  return context;
}
